import * as React from 'react';
const MOBILE_BREAKPOINT = 768;
export function useIsMobile() {
    // Initialisé directement au rendu (initialiseur paresseux) plutôt que via un
    // `setState` synchrone dans l'effet, qui déclencherait un rendu supplémentaire
    // évitable au montage.
    const [isMobile, setIsMobile] = React.useState(() => globalThis.window !== undefined && window.innerWidth < MOBILE_BREAKPOINT);
    React.useEffect(() => {
        const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
        const onChange = () => {
            setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
        };
        mql.addEventListener('change', onChange);
        return () => {
            mql.removeEventListener('change', onChange);
        };
    }, []);
    return !!isMobile;
}
